import template from './login.html';
import controller from './login.controller';
import './login.scss';

let LoginComponent = {
  bindings: {},
  template,
  controller
};

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.js